var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 10.6523V21.7148C3.75 21.9138 3.82902 22.1045 3.96967 22.2452C4.11032 22.3858 4.30109 22.4648 4.5 22.4648H9V16.0898C9 15.7915 9.11853 15.5053 9.3295 15.2943C9.54048 15.0834 9.82663 14.9648 10.125 14.9648H13.875C14.1734 14.9648 14.4595 15.0834 14.6705 15.2943C14.8815 15.5053 15 15.7915 15 16.0898V22.4648H19.5C19.6989 22.4648 19.8897 22.3858 20.0303 22.2452C20.171 22.1045 20.25 21.9138 20.25 21.7148V10.6523",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 12.714L12.5105 3.15152C12.2761 2.90402 11.7281 2.90121 11.4895 3.15152L1.5 12.714",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.75 9.10547V3.71484H16.5V6.94922",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHomeIcon);
export default __webpack_public_path__ + "static/media/dashboard_home_icon.5611cb2d8f282b9b85d030d99b4dc094.svg";
export { ForwardRef as ReactComponent };